// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"Label_inputLabel__4EfdG","tip":"Label_tip__TsvQy"};